export interface IPhysician {
    physicianId: string,
    physicianUId: string,
    nameEnglish: string,
    nameArabic: string,
    specialityId: string,
    specialityCode: string;
    specialityNameEnglish: string,
    specialityNameArabic: string,
    roleId: string,
    roleNameEnglish: string;
    roleNameArabic: string;
    clinic: string;
    email: string;
    isDoctorRegistered: boolean;
    mobileNumber: string;
    registrationNumber: string;
};

export const physicianConfig = {
    entityName: 'CONFIGURATION.PHYSICIAN.TITLE',
    physicianUid: 'CONFIGURATION.PHYSICIAN.ID',
    nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
    nameArabic: 'FORM_FIELD.ARABIC_NAME',
    specialityId: 'CONFIGURATION.SPECIALITY.TITLE',
    roleId: 'FORM_FIELD.ROLE',
    clinic: 'CONFIGURATION.PHYSICIAN.CLINIC',
    email: 'FORM_FIELD.EMAIL',
    isDoctorRegistered: 'CONFIGURATION.PHYSICIAN.IS_PHYSICIAN_REGISTERED',
    mobileNumber: 'FORM_FIELD.MOBILE_NO',
    registrationNumber: 'CONFIGURATION.PHYSICIAN.REGISTRATION_NUMBER',
    registrationNumValidation: 'CONFIGURATION.PHYSICIAN.PHYSICIAN_REGISTRATION_ERROR_MSG',
    clinicValidation: 'CONFIGURATION.PHYSICIAN.CLINIC_VALIDATION'
};
